import { Box, Button, Paper, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'
import SearchOffRoundedIcon from '@mui/icons-material/SearchOffRounded'
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function NotFound({ basePath, title, message }) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleBack = () => navigate(basePath ? `${basePath}/..` : -1)

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 360, }}>
      <Paper
        elevation={0}
        sx={{
          width: '100%',
          textAlign: 'center',
          p: { xs: 3, sm: 5 },
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Box
          sx={{
            width: 88,
            height: 88,
            mx: 'auto',
            mb: 2.5,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'primary.main',
            bgcolor: theme => alpha(theme.palette.primary.main, 0.08),
          }}
        >
          <SearchOffRoundedIcon sx={{ fontSize: 44 }} />
        </Box>

        {title && (
          <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: 1 }}>
            {t(title)}
          </Typography>
        )}

        <Typography variant="h5" fontWeight={700} gutterBottom>
          {t('Not Found')}
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3, maxWidth: 340, mx: 'auto' }}>
          {t(message || 'The page you are looking for does not exist or may have been moved.')}
        </Typography>

        <Button variant="contained" startIcon={<ArrowBackRoundedIcon />} onClick={handleBack}>
          {t('Go Back')}
        </Button>
      </Paper>
    </Box>
  )
}
